var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"download-button__link",attrs:{"href":"/plugindownload/master/","target":"_blank"},on:{"click":_vm.logDownloadPluginBIMLIBMaster}},[_c('bim-button',{staticClass:"download-button__button",attrs:{"label":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }